import React from "react"
import { ChartDetailProps } from "./ChartDetail.types";
import { ChartDetailContainer, ChartDetailFulltext, ChartDetailValue, ChartDetailRect, ChartDetailText } from "./ChartDetail.styled";


/**
 * Chart detail (atom)
 *  for donut chart
 *
 * @param props
 * @returns React Component
 */
const ChartDetail = ({color,value,text,isLoading=false }:ChartDetailProps) => {

  return <ChartDetailContainer data-testid="chart-detail" isLoading={isLoading}>
            <ChartDetailRect color={color}/>
            <ChartDetailFulltext>
              <ChartDetailValue>{value}</ChartDetailValue>
              <ChartDetailText> {text}</ChartDetailText>
            </ChartDetailFulltext>
          </ChartDetailContainer>;

}

export default ChartDetail;